import { Row, Col, Accordion, Alert } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import NewsLetterButton from './NewsLetterButton';
import React from "react";

const SCHOOL_YEAR_MONTH_ORDER = {
    September: 0,
    October: 1,
    November: 2,
    December: 3,
    January: 4,
    February: 5,
    March: 6,
};

const getMonthSortIndex = (monthLabel = '') => {
    const firstMonth = monthLabel.split('-')[0]?.trim();
    if (Object.prototype.hasOwnProperty.call(SCHOOL_YEAR_MONTH_ORDER, firstMonth)) {
        return SCHOOL_YEAR_MONTH_ORDER[firstMonth];
    }

    return Number.MAX_SAFE_INTEGER;
};

function NewsLetterAccordion({ schoolBrochures }) {
    const { i18n } = useTranslation('sateliteSchools');

    if (!schoolBrochures) {
        return null;
    }

    if (schoolBrochures.isNurseryNoticeOnly) {
        return (
            <>
                <h2 className="justify-content-center d-flex mt-5"><Trans ns="sateliteSchools" i18nKey="school brochure" /></h2>
                <Alert variant="info" className="mt-3 mb-0">
                    <Trans ns="sateliteSchools" i18nKey="nursery brochure message" />
                </Alert>
            </>
        );
    }

    const years = Object.keys(schoolBrochures).filter((year) => Array.isArray(schoolBrochures[year]));

    if (!years.length) {
        return (
            <>
                <h2 className="justify-content-center d-flex mt-5"><Trans ns="sateliteSchools" i18nKey="school brochure" /></h2>
                <Alert variant="secondary" className="mt-3 mb-0">
                    <Trans ns="sateliteSchools" i18nKey="brochure unavailable message" />
                </Alert>
            </>
        );
    }

    const sortedYears = years.sort((a, b) => b.localeCompare(a));

    function generateRow(brochures) {
        const isUkrainian = i18n.language.startsWith('ua');
        const sortedBrochures = [...brochures].sort((a, b) => {
            const monthDelta = getMonthSortIndex(a?.month) - getMonthSortIndex(b?.month);
            if (monthDelta !== 0) {
                return monthDelta;
            }

            return (a?.title || '').localeCompare(b?.title || '');
        });

        return sortedBrochures.map((brochure, index) => {
            if (!brochure?.title || !brochure?.previewUrl) {
                return null;
            }

            const monthText = isUkrainian ? (brochure.monthUa || brochure.month) : brochure.month;
            const titleText = isUkrainian ? (brochure.titleUa || brochure.title) : brochure.title;
            const itemKey = `${brochure.sharedUrl || brochure.previewUrl}-${index}`;

            return (
                <React.Fragment key={itemKey}>
                    <Row>
                        <Col sm={12}>
                            <strong>{monthText}</strong>
                            {monthText ? ` - ${titleText}` : titleText}
                        </Col>
                        <Col sm={12} className="mt-2">
                            <NewsLetterButton brochure={{ ...brochure, title: titleText }}></NewsLetterButton>
                        </Col>
                    </Row>
                    <hr></hr>
                </React.Fragment>
            );
        });
    }
    return (
 
 <>
            <h2 className="justify-content-center d-flex mt-5"><Trans ns="sateliteSchools" i18nKey="school brochure" /></h2>
            <Accordion>
                {sortedYears.map((year, index) => (
                    <Accordion.Item eventKey={String(index)} key={year}>
                        <Accordion.Header>{year}</Accordion.Header>
                        <Accordion.Body>
                            {generateRow(schoolBrochures[year])}
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </>)
}

export default NewsLetterAccordion;